export const capabilitiesList = [
  // editor
  'editor',
  // drafts
  'editor.draft',
  'editor.draft.create',
  'editor.draft.update',
  'editor.draft.delete',
  'editor.draft.customDeny',
  // draft steps
  'editor.draft.targeting',
  'editor.draft.content',
  'editor.draft.newsletter',
  'editor.draft.occasion',
  'editor.draft.survey',
  'editor.draft.reminders',
  'editor.draft.documents',
  'editor.draft.preview',
  'editor.planned',
  'editor.published',
  // management
  'management',
  'management.list',
  'management.list.create',
  'management.list.update',
  'management.list.delete',
  'management.list.customDeny',
  // settings
  'settings'
] as const;

export type Capability = (typeof capabilitiesList)[number];
export type Capabilities = Record<Capability, boolean> & {
  // contains any sub-capability
  [K in Capability as `${K}.*`]: boolean;
};
